<template>
   <b-modal id="modalManageUnits" modal-class="modal-fullscreen" title="Eenheden beheren" hide-backdrop
      size="md" scrollable
      @show="focusInput"
      hide-footer>
      <p class="text-muted small">
         Eenheden die je hier toevoegt of aanpast, verschijnen in de eenheid-keuzelijst bij een
         recept-ingrediënt. Bestaande recepten behouden hun eigen eenheid.
      </p>

      <!-- Nieuwe eenheid toevoegen -->
      <b-form @submit.stop.prevent="addUnit" class="mb-3">
         <b-row class="mb-1">
            <b-col cols="5" class="pr-1">
               <b-form-input ref="inputNaam" v-model="newUnit.naam" placeholder="naam (bijv. eetlepel)" :state="newUnitValid" size="sm" />
            </b-col>
            <b-col cols="4" class="px-1">
               <b-form-input v-model="newUnit.meervoud" placeholder="meervoud" size="sm" />
            </b-col>
            <b-col cols="3" class="pl-1">
               <b-form-input v-model="newUnit.afkorting" placeholder="afk." size="sm" />
            </b-col>
         </b-row>
         <b-button type="submit" variant="primary" size="sm" :disabled="newUnitValid !== true">
            <b-icon icon="plus" /> Toevoegen
         </b-button>
         <b-form-invalid-feedback :state="newUnitValid">{{ newUnitInvalidInfo }}</b-form-invalid-feedback>
      </b-form>

      <!-- Eenheden-lijst -->
      <b-list-group flush>
         <b-list-group-item v-for="row in rows" :key="row.id"
            class="d-flex justify-content-between align-items-center py-2 px-1">
            <template v-if="editingId === row.id">
               <b-row class="flex-grow-1 mr-1 no-gutters">
                  <b-col cols="5" class="pr-1"><b-form-input v-model="editing.naam" size="sm" @keydown.enter.prevent="saveEdit" /></b-col>
                  <b-col cols="4" class="px-1"><b-form-input v-model="editing.meervoud" size="sm" placeholder="meervoud" /></b-col>
                  <b-col cols="3" class="pl-1"><b-form-input v-model="editing.afkorting" size="sm" placeholder="afk." /></b-col>
               </b-row>
               <div class="text-nowrap">
                  <b-button size="sm" variant="success" class="mr-1" @click="saveEdit"><b-icon icon="check" /></b-button>
                  <b-button size="sm" variant="secondary" @click="cancelEdit"><b-icon icon="x" /></b-button>
               </div>
            </template>
            <template v-else>
               <span>{{ row.naam }}<small class="text-muted" v-if="row.meervoud || row.afkorting"> ({{ [row.meervoud, row.afkorting].filter(Boolean).join(', ') }})</small>
                  <b-badge v-if="!row.local" variant="light" class="ml-1">standaard</b-badge>
               </span>
               <div v-if="row.local" class="text-nowrap">
                  <b-button size="sm" variant="outline-primary" class="mr-1" @click="startEdit(row)"><b-icon icon="pencil" /></b-button>
                  <b-button size="sm" variant="outline-danger" @click="deleteUnit(row)"><b-icon icon="trash" /></b-button>
               </div>
            </template>
         </b-list-group-item>
      </b-list-group>
      <small class="text-muted">{{ rows.length }} eenheden</small>
   </b-modal>
</template>
<script>

import db from "../db.js"

export default {
   name: "modal-manage-units",
   props: ["userID", "units"],
   data: function() {
      return {
         newUnit: { naam: "", meervoud: "", afkorting: "" },
         newUnitInvalidInfo: "",
         editingId: null,
         editing: { naam: "", meervoud: "", afkorting: "" },
      };
   },
   computed: {
      rows: function() {
         return this.units.map(u => ({
            id: u.value.id,
            naam: u.value.naam,
            meervoud: u.value.meervoud || "",
            afkorting: u.value.afkorting || "",
            local: u.local === true,
         }))
      },
      newUnitValid: function() {
         if(!this.newUnit.naam) return null
         const naam = this.newUnit.naam.trim()
         if(naam == "") return false
         const exists = this.units.some(u => u.text && u.text.toLowerCase() == naam.toLowerCase())
         return !exists
      },
      now: function() {
         var date = new Date();
         return (
            String (date.getHours()) +
            String (date.getMinutes()) +
            String (date.getSeconds())
         )
      },
   },
   methods: {
      focusInput: function() {
         setTimeout(() => {
            if(this.$refs.inputNaam) this.$refs.inputNaam.focus()
         }, 500)
      },
      unitId: function(naam) {
         return (naam
            .toLowerCase()
            .replace(/[^\w ]+/g, '')
            .replace(/ +/g, '-') + "-" + this.now)
      },
      addUnit: function() {
         const naam = this.newUnit.naam.trim()
         if(naam == "") {
            this.newUnitInvalidInfo = "Geef een naam op"
            return
         }
         if(this.newUnitValid !== true) {
            this.newUnitInvalidInfo = "Eenheid bestaat al"
            return
         }
         const id = this.unitId(naam)
         db.collection("users").doc(this.userID).collection("units").doc(id)
            .set({ id: id, naam: naam, meervoud: (this.newUnit.meervoud || "").trim(), afkorting: (this.newUnit.afkorting || "").trim() })
            .then(() => { this.newUnit = { naam: "", meervoud: "", afkorting: "" } })
            .catch(error => console.log(error))
      },
      startEdit: function(row) {
         this.editingId = row.id
         this.editing = { naam: row.naam, meervoud: row.meervoud, afkorting: row.afkorting }
      },
      saveEdit: function() {
         const naam = this.editing.naam.trim()
         if(naam == "") return
         db.collection("users").doc(this.userID).collection("units").doc(this.editingId)
            .update({ naam: naam, meervoud: (this.editing.meervoud || "").trim(), afkorting: (this.editing.afkorting || "").trim() })
            .then(() => this.cancelEdit())
            .catch(error => console.log(error))
      },
      cancelEdit: function() {
         this.editingId = null
         this.editing = { naam: "", meervoud: "", afkorting: "" }
      },
      deleteUnit: function(row) {
         if(!confirm(`Weet je zeker dat je eenheid '${row.naam}' wilt verwijderen? Bestaande recepten behouden hun eenheid.`)) return
         db.collection("users").doc(this.userID).collection("units").doc(row.id)
            .delete()
            .catch(error => console.log(error))
      },
   },
}
</script>
